import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { PATH_DELIMITER, SEMESTER_ENROLMENT_STATUS_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const TAB_NO = 'TAB1';

const ACTION_SEARCH = SEMESTER_ENROLMENT_STATUS_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_EXCEL_DOWNLOAD =
    SEMESTER_ENROLMENT_STATUS_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';
const ACTION_EXCEL_UPLOAD =
    SEMESTER_ENROLMENT_STATUS_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EXCEL_UPLOAD';
const ACTION_EDIT = SEMESTER_ENROLMENT_STATUS_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EDIT';
const HANDLE_GRID_DATA = SEMESTER_ENROLMENT_STATUS_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'HANDLE_GRID_DATA';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);
export const actionExcelUpload = createAction(ACTION_EXCEL_UPLOAD);
export const actionEdit = createAction(ACTION_EDIT);

export function* semesterEnrolmentStatusViewTab1BodySagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
    yield takeEvery(ACTION_EXCEL_UPLOAD, actionExcelUploadSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    if (!params.semesterId) {
        params.semesterId = 'ALL';
    }

    const result = yield call(request, {
        method: 'get',
        url: `/api/enrolment-university/semesters/${params.semesterId}/universities/${params.lessonUniversityCd}/users`,
        params,
        callback,
    });

    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionEditSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/enrolment-university/semesters/${data.semesterId}/universities/${data.lessonUniversityCd}/users/${data.userId}`,
        data,
        callback,
    });
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    yield call(request, {
        method: 'get',
        url: `/api/enrolment-university/semesters/${params.semesterId}/universities/${params.lessonUniversityCd}/users-excel-export`,
        params,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}
function* actionExcelUploadSaga({ payload: { params, callback, uploadProgress } }) {
    const formData = new FormData();
    formData.append('file', params.file);
    yield call(request, {
        method: 'post',
        url: `/api/enrolment-university/semesters/${params.semesterId}/universities/${params.lessonUniversityCd}/users-excel-import`,
        data: formData,
        upload: true,
        uploadProgress,
        callback,
    });
}

const initialState = {
    gridData: defaultGridData,
};

const module = handleActions(
    {
        [HANDLE_GRID_DATA]: (state, { payload: gridData }) => ({ ...state, gridData }),
    },
    initialState,
);

export default module;
